import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * @param {ParentNode} root
 * @param {string | undefined} blockId
 * @returns {Element | null}
 */
function findProductInventoryInDocument(root, blockId) {
  if (blockId) {
    const candidates = root.querySelectorAll('product-inventory');
    const match = Array.from(candidates).find((el) => el.dataset.blockId === blockId);
    if (match) return match;
  }
  return root.querySelector('product-inventory');
}

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const doc = event.detail?.data?.html;
    if (!doc || typeof doc.querySelector !== 'function') return;

    const blockId = this.dataset.blockId;
    const newInventory = findProductInventoryInDocument(doc, blockId);

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
